export const HELP_GOALS_LIST = [{
  titleKey: 'steps.0.title',
  descriptionKey: 'steps.0.description'
}, {
  titleKey: 'steps.1.title',
  descriptionKey: 'steps.1.description'
}, {
  titleKey: 'steps.2.title',
  descriptionKey: 'steps.2.description',
  listTitleKey: 'steps.2.listTitle',
  listPointsKeys: ['steps.2.listPoints.0', 'steps.2.listPoints.1', 'steps.2.listPoints.2', 'steps.2.listPoints.3']
}];